export default __webpack_public_path__ + "static/media/instagram_m_logo.9fe35e01.svg";